// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "ac9d4aa2",
    "hash": "ac9d4aa2",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "ac9d4aa2",
    "semverString": null,
    "timestamp": 1750888944983,
    "dateStr": "Wed Jun 25 2025 22:02:24 GMT+0000 (Coordinated Universal Time)"
};
/* tslint:enable */
